import { calcSalary } from './calcSalary';

export const calcSalaryForOne = (data, payment) => {
	
	const result =
		calcSalary(data, payment) /
			((data.delivered_count || 0) - (data.ignore_bonus_count || 0) || 1);
	return Math.round(result * 100) / 100;
};
